import { LinkWithTitle } from '@/components/links';
import { CHRISTMAS_BOAT_PARADE_TITLE } from '@/pages/special-events/christmas-boat-parade';
import { FOURTH_OF_JULY_TITLE } from '@/pages/special-events/fourth-of-july';
import { GASPARILLA_PARADE_TITLE } from '@/pages/special-events/gasparilla-parade';
import { LABOR_DAY_WEEKEND_TITLE } from '@/pages/special-events/labor-day-weekend';
import { MEMORIAL_DAY_TITLE } from '@/pages/special-events/memorial-day';

export const SpecialEventsList = () => {
  return (
    <>
      <li>
        <LinkWithTitle to="/special-events/christmas-boat-parade">
          {CHRISTMAS_BOAT_PARADE_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/special-events/fourth-of-july">
          {FOURTH_OF_JULY_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/special-events/gasparilla-parade">
          {GASPARILLA_PARADE_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/special-events/labor-day-weekend">
          {LABOR_DAY_WEEKEND_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/special-events/memorial-day">
          {MEMORIAL_DAY_TITLE}
        </LinkWithTitle>
      </li>
    </>
  );
};
